const ZARppayOptions = [
    {label: "Absa", value: "10010"},
    {label: "NedBank", value: "10011"},
    {label: "Capitec", value: "10012"},
    {label: "Standard", value: "10013"},
    {label: "Fnb", value: "10014"},
    {label: "African Bank", value: "10015"},
    {label: "Bidvest Bank", value: "10016"},
    {label: "Discovery", value: "10017"},
    {label: "FirstRand Bank", value: "10019"},
    {label: "Grindrod Bank", value: "10020"},
    {label: "Imperial Bank", value: "10021"},
    {label: "Investec Bank", value: "10022"},
    {label: "Sasfin Bank", value: "10023"},
    {label: "Ubank", value: "10025"},
    {label: "TymeBank", value: "10026"},
    {label: "Mercantile Bank", value: "10027"},
    {label: "Albaraka Bank", value: "10028"},
    {label: "HBZ Bank", value: "10029"},
    {label: "Habib Overseas Bank", value: "10030"},
    {label: "Wesbank", value: "10031"},
    {label: "Rand Merchant Bank", value: "10032"},
    {label: "Bank of Athens", value: "10033"},
];

export default ZARppayOptions;
